export const collapsibleHelp = {
	title: "informations",
	'hide-label' : "masquer l'aide",
	'show-label' : "afficher l'aide"
}
